import { useTranslation } from '@gimlite/common';
import {
  Timeline,
  TimelineType,
} from '../../components/timeline/timeline.component';

export declare namespace PaymentNotifiedSessionTimelineType {
  type Props = {
    data: {
      date: TimelineType.Data.Date;
      extra?: TimelineType.Data.Extra;
      device: TimelineType.Data.Device;
    };
  };
}

export const PaymentNotifiedSessionTimeline = ({
  data: { date, extra, device },
}: PaymentNotifiedSessionTimelineType.Props) => {
  const { t } = useTranslation();
  return (
    <Timeline
      config={{
        color: 'label',
      }}
      data={{
        icon: 'faCoinsSolid',
        date,
        device,
        title: t('global-state-payment-notified'),
        extra,
      }}
    />
  );
};
